import React from 'react';

import useCanEditField from 'pages/RequestFigurant/useCanEditField';
import * as S from './styles';

interface StepperProps {
  currentStep?: number;
  steps: string[];
  stepHandler?: (step: number) => void;
  canBackStep?: boolean;
  isEditing?: boolean;
}

export const Stepper: React.FC<StepperProps> = ({ currentStep = 1, steps, stepHandler = () => {}, isEditing }) => {
  const { getStepsForEdit } = useCanEditField();

  const stepsForEdit = getStepsForEdit();

  return (
    <S.Container justOneStep={steps.length === 1}>
      {steps.map((step, index) => {
        const stepOrder = index + 1;
        const enableToEdit = isEditing && stepsForEdit.includes(stepOrder);
        const hasClick = enableToEdit ?? stepOrder < currentStep;

        const onCLickStep = (step: number) => {
          stepHandler(step);
        };

        return (
          <S.StepContent key={index}>
            <S.StepOrder
              isCurrentStep={currentStep === stepOrder}
              onClick={enableToEdit ? () => onCLickStep(stepOrder) : () => console.log('no click')}
              hasClick={hasClick}
            >
              {stepOrder}
            </S.StepOrder>
            <S.StepText isCurrentStep={currentStep === stepOrder}>{step}</S.StepText>
          </S.StepContent>
        );
      })}
    </S.Container>
  );
};

export default Stepper;
